module.exports = __webpack_public_path__ + "static/media/4.f2ee0063.jpg";